import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/recaudacion/bitacoras-de-recepcion-folio-vehicular/';

/**
 * GET AlmacenesVehiculares
 * @returns {Promise<Array<object>>}
 */
export const getBitacorasRecepcionesFoliosVehiculares = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET BitacoraRecepcionFolioVehicular
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getBitacoraRecepcionFolioVehicular = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST BitacoraRecepcionFolioVehicular
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postBitacoraRecepcionFolioVehicular = async (values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH BitacoraRecepcionFolioVehicular
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchBitacoraRecepcionFolioVehicular = async (id, values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE BitacoraRecepcionFolioVehicular
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteBitacoraRecepcionFolioVehicular = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
